export type ModuleName = "formative"
export const MODULE_NAME: ModuleName = "formative"
